/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFetchQuery } from './useFetchQuery'
import { eventWaiverBySlug } from '../api/queries'
import { Event } from '../models/API'
import { fetchQuery } from '../utils/ApiUtils'
import { jsonParse } from '../utils/ObjectUtil'

interface Props {
  slug: string | null | undefined
}

const useEventWaiver = ({ slug }: Props) => {
  const { data: event, apiLoading, apiError } = useFetchQuery(
    async () => {
      const { items } = (await fetchQuery('eventBySlug', eventWaiverBySlug, {
        slug,
      })) as unknown as { items: Event[] }

      if (items.length > 0)
        return {
          ...items[0],
          waiver: jsonParse(jsonParse(items[0].waiver as string)),
        }
      return null
    },
    [slug],
    'Fail to load event',
    { guard: !!slug },
  )

  return { event, apiLoading, apiError }
}

export default useEventWaiver
